export const SheetName = ({ name }: { name: string }) => {
  return (
    <span className="rounded-[8px] border border-[#cbcbce] px-2 py-0.5 text-[11px] font-bold leading-[16px] text-black">
      {name}
    </span>
  )
}
